import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function UnfoldMoreDoubleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"unfold_more_double"}/>
}
